<!-- @86942 - depreciado -->
<template>
    <div :id="!isExpanded ? 'main' : 'expanded'">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t("nova-parametrizacao") }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    tag="button"
                    @click="fechar()"
                >
                    {{ $t("fechar") }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="isLoading"
                >
                    {{ $t("salvar") }}
                    <button-loader :isSaving="isLoading" />
                </button>
            </div>
        </div>
        <br />
        <section>
            <div class="modal-card">
                <section class="modal-card-body modal-es">
                    <div class="columns">
                        <div class="column">
                            <label v-text="$t('parametrizacao')" />
                            <v-select
                                ref="situacoesInput"
                                class="nova-parametrizacao-select"
                                :options="configs"
                                v-model="configSelecionada"
                                :clearable="false"
                                @input="onCleanConfigs"
                            >
                            </v-select>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div class="conteudo-parametrizacao-valor">
                                <label
                                    ><span>{{ $t("valor") }}</span></label
                                >
                                <v-select
                                    v-if="options.length != 0"
                                    ref="valorSelect"
                                    label="label"
                                    :options="options"
                                    :clearable="false"
                                    v-model="selected"
                                    @input="getUsersConfigsByNameAndValue"
                                />
                                <input
                                    v-model="inputText"
                                    :type="typeInput"
                                    v-else
                                />
                            </div>
                        </div>
                    </div>
                    <div class="columns content">
                        <div class="column">
                            <label
                                ><span>{{ $t("vendedores") }}</span></label
                            >
                            <vss-select
                                v-model="vendedoresSelecionados"
                                label="nome"
                                :options="vendedores"
                                :loading="vendedoresLoading"
                                :closeOnSelect="false"
                                @search="loadVendedores"
                                @input="clearSelect($event, 'vendedores')"
                                no-clearfix
                                multiple
                                clearable
                                searchable
                            >
                            <template #multiple-selected="{ selected }">
                                    ({{
                                        selected && selected.length > 0
                                            ? selected.length
                                            : $t("todos")
                                    }})
                            </template>
                            </vss-select>
                        </div>
                    </div>
                    <div class="columns content">
                        <div class="column">
                            <v-textarea
                                ref="obsTextArea"
                                class="obs-ta"
                                v-model="descricao"
                                title="descricao"
                                :maxlength="2000"
                                :readonly="true"
                                :disabled="true"
                            />
                        </div>
                    </div>
                </section>
            </div>
        </section>
    </div>
</template>

<script>
import ParametrizacaoUsuarioService from "@/services/ParametrizacaoUsuarioService";
import ParametrizacaoService from "@/services/ParametrizacaoService";
import Message from "@/models/Message";
import ColaboradorService from "@/services/ColaboradorService";

// @86942 - depreciado
export default {
    data() {
        return {
            isLoading: false,
            serviceUser: new ParametrizacaoUsuarioService(
                this.$http,
                this.$router
            ),
            serviceConfig: new ParametrizacaoService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(
                this.$http,
                this.$router
            ),
            selected: null,
            options: [],
            msgs: [],
            configs: [],
            vendedores: [],
            inputText: "",
            typeInput: "text",
            vendedoresLoading: false,
            vendedoresSelecionados: [],
            usrsConfigs: [],
            isExpanded: false,
            configSelecionada: null,
            descricao: "",
        };
    },
    props: {
        parametrizacaoUsuario: {},
    },
    created() {
        this.loadConfigs();
        this.loadVendedores();
    },
    methods: {
        fechar() {
            this.$emit("fecharModal", "nova");
        },
        renderInput(value) {
            if (value.tipo) {
                let json = JSON.parse(value.tipo);
                if (json.type === "select") {
                    this.options = json.options.map((e) => ({
                        id: e.value,
                        label: e.name,
                    }));
                    this.selected = this.options[0];
                } else {
                    this.typeInput = json.type;
                }
            }
        },
        updateExpanded() {
            this.isExpanded = !this.isExpandend;
        },
        buscaVendedoresSelecionados(vendedoresUsamconfig) {
            this.vendedores.forEach((v) => {
                if (vendedoresUsamconfig.idusuario == v.idusuario) {
                    return this.vendedoresSelecionados.push(v);
                }
            });
        },
        carregarVendedoresSelecionados() {
            this.vendedoresSelecionados = [];
            this.usrsConfigs.forEach((u) => {
                this.buscaVendedoresSelecionados(u);
            });
        },
        onCleanConfigs(val) {
            this.options = [];
            this.selected = {};
            this.vendedoresSelecionados = [];
            if (val) {
                this.renderInput(val);
                this.descricao = val.descricao;
                this.getUsersConfigsByNameAndValue();
            }
        },
        loadConfigs(search) {
            this.serviceConfig
                .findAllCombo(search)
                .then((value) => {
                    if (value.status === 200) {
                        if (value.content) {
                            value.content.map((e) => {
                                this.configs.push({
                                    id: e.idconfig,
                                    label: e.label,
                                    nome: e.nome,
                                    descricao: e.descricao,
                                    tipo: e.tipo,
                                    idcategoriaconfig: e.idcategoriaconfig,
                                });
                            });

                            this.configSelecionada = this.configs[0];

                            this.renderInput(this.configSelecionada);
                            this.descricao = this.configSelecionada.descricao;
                        }
                    } else {
                        this.configs = [];
                        this.configSelecionada = {};
                        this.msgs.push(
                            new Message("error", "msg-erro-load", true)
                        );
                    }
                })
                .catch((e) => {
                    console.error("Erro ao carregar as parametrizacoes.", e);
                })
                .finally((_) => {
                    this.vendedoresLoading = false;
                });
        },
        loadVendedores(q) {
            this.vendedoresLoading = true;
            this.colaboradorService
                .findListAssociated(q != null ? q : "", 5000000)
                .then((r) => {
                    this.vendedores = r.content;
                })
                .catch((e) => {
                    console.error("Erro ao carregar vendedores.", e);
                })
                .finally((_) => {
                    setTimeout(() => {
                        this.getUsersConfigsByNameAndValue();
                    }, 200);
                    this.vendedoresLoading = false;
                });
        },
        save() {
            this.isLoading = true;
            let listagemConfig = [];
            this.vendedoresSelecionados =
                this.vendedoresSelecionados.length > 0
                    ? this.vendedoresSelecionados
                    : this.vendedores;
            this.vendedoresSelecionados.forEach((v) => {
                let obj = { ...this.configSelecionada };
                obj.idusuario = v.idusuario;
                obj.usuarios = 0;
                if (this.selected.id) {
                    obj.valor = this.selected.id;
                } else {
                    obj.valor = this.inputText;
                }
                listagemConfig.push(obj);
            });
            this.serviceUser
                .save(listagemConfig)
                .then((value) => {
                    if (value.content == null) {
                        this.msgs.push(
                            new Message(
                                "error",
                                "erro-inserir-parametrizacao",
                                true
                            )
                        );
                    } else {
                        this.msgs.push(
                            new Message(
                                "success",
                                "sucesso-inserir-parametrizacao",
                                true
                            )
                        );
                        setTimeout(() => {
                            this.fechar();
                        }, 1000);
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        getUsersConfigsByNameAndValue() {
            /* Esse metodo trás todos os usuarios que estão utilizando essa config com esse valor */
            this.serviceUser
                .getAllUsersConfigsByValueAndName(
                    this.configSelecionada.nome,
                    this.selected.id
                )
                .then((r) => {
                    this.usrsConfigs = r.content;
                })
                .catch((e) => {
                    console.error("Erro ao carregar configs.", e);
                })
                .finally((_) => {
                    this.carregarVendedoresSelecionados();
                });
        },
        clearSelect(value, select) {
            if (value.length == 0) {
                if (select == "vendedores") this.vendedoresSelecionados = [];
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px !important;
    height: 100%;

    span {
        font-size: 13px;
    }

    .conteudo-parametrizacao {
        display: flex;
        align-items: center;
        padding: 20px 0px;
        flex-direction: column;

        .conteudo-parametrizacao-descricao {
            width: 70%;
        }

        .conteudo-parametrizacao-valor {
            display: flex;
            align-items: center;
            flex-direction: row;
            width: 80%;
            margin-top: 15px;

            span {
                margin-right: 10px;
            }

            div {
                width: 100%;
            }
        }
    }
    .obs-ta {
        flex-grow: 1;
        min-height: 250px;
    }
}

#expanded {
    padding: 20px 20px !important;
    height: 800px;

    span {
        font-size: 13px;
    }

    .conteudo-parametrizacao {
        display: flex;
        align-items: center;
        padding: 20px 0px;
        flex-direction: column;

        .conteudo-parametrizacao-descricao {
            width: 70%;
        }

        .conteudo-parametrizacao-valor {
            display: flex;
            align-items: center;
            flex-direction: row;
            width: 80%;
            margin-top: 15px;

            span {
                margin-right: 10px;
            }

            div {
                width: 100%;
            }
        }
    }
}
</style>